import React, { useState } from 'react';

const ICEGATERegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with ICEGATE Registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with ICEGATE registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-14 pb-14">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4 leading-tight">
              ICEGATE Registration
            </h1>
            <p className="text-xl text-blue-100 mb-8">
              Your trusted partner for effortless ICEGATE Registration. We simplify the mandatory online process for importers, exporters, and other trade partners to interact with Indian Customs through the Indian Customs Electronic Gateway (ICEGATE).
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="#contact-section"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out"
              >
                Get Started Today
                <span className="ml-2">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#Overview">Overview</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#types">Key Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Our Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#deliverables">Deliverables</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#faqs">Common Questions</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="Overview" className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <span className="text-sm font-semibold uppercase text-blue-600"
                >Understanding Customs Compliance</span
              >
              <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-6">
                What is ICEGATE and Why is Registration Mandatory?
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                <strong>ICEGATE</strong> (Indian Customs Electronic Gateway) is the national portal of Indian Customs, which offers e-filing services to the trade, cargo carriers, and other clients. It acts as a primary interface for all online transactions with the Customs Department, including the submission of Bills of Entry, Shipping Bills, and electronic payment of duties.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-3 mt-1">✅</span>
                  <p className="text-gray-700">
                    <strong>Mandatory for Trade:</strong> All importers, exporters, and customs brokers must register on ICEGATE to conduct any Customs-related business electronically.
                  </p>
                </div>
                <div className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-3 mt-1">✅</span>
                  <p className="text-gray-700">
                    <strong>Single Point of Contact:</strong> It facilitates all communication and data exchange between Customs and external trade partners, streamlining the entire process.
                  </p>
                </div>
                <div className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-3 mt-1">✅</span>
                  <p className="text-gray-700">
                    <strong>Paperless Transaction:</strong> Registration enables a fully digital and paperless environment for trade documentation and payment.
                  </p>
                </div>
              </div>
            </div>
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with ICEGATE Registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section id="types" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">
              Key Benefits of ICEGATE Registration
            </h2>
            <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
              Registration opens up a host of digital services crucial for efficient import and export trade.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "E-Filing of Documents", desc: "Submit Bills of Entry, Shipping Bills, and various applications directly to Customs electronically." },
              { icon: "💳", title: "Electronic Duty Payment", desc: "Pay Customs duties and other charges instantly and securely online, reducing transaction time." },
              { icon: "📊", title: "Access to Trade Data", desc: "View and track the status of your Bills of Entry, Shipping Bills, and refund claims in real-time." },
              { icon: "⚖️", title: "Facilitates Compliance", desc: "Ensures seamless integration with other regulatory bodies and facilitates compliance with all Customs regulations." },
              { icon: "🔐", title: "Secure and Private Access", desc: "Provides a secure, password-protected environment for all your sensitive trade and financial data." },
              { icon: "🚀", title: "Faster Clearance", desc: "The digital platform significantly speeds up the processing and clearance of import and export consignments." }
            ].map((benefit, index) => (
              <div key={index} className="p-6 border border-gray-200 rounded-lg bg-white flex items-start space-x-4 shadow-md hover:shadow-lg transition duration-300">
                <span className="text-2xl flex-shrink-0 mt-1">{benefit.icon}</span>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                  <p className="text-gray-600 text-sm">{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="procedure" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-sm font-semibold uppercase text-blue-600"
              >Our Simplified Process</span
            >
            <h2 className="text-3xl font-bold text-gray-900 mt-2">
              The ICEGATE Registration Procedure
            </h2>
            <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
              We manage the entire registration lifecycle, ensuring your seamless transition to the digital Customs platform.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: "1", icon: "📁", title: "Document Collection & Verification", desc: "You provide the necessary documents, including IEC, GSTIN, and identity proof. We meticulously verify all data for accuracy." },
              { number: "2", icon: "📤", title: "Online Application Submission", desc: "Our experts draft and submit the registration application on the ICEGATE portal using the required digital signature." },
              { number: "3", icon: "🔍", title: "Application Tracking & Follow-up", desc: "We continuously monitor the application status and respond to any queries or rectifications requested by the Customs officials." },
              { number: "4", icon: "🎯", title: "Final Confirmation & Credentials", desc: "Once approved, the ICEGATE User ID and password are generated. We deliver the digital confirmation and guide you on initial usage." }
            ].map((step, index) => (
              <div key={index} className="relative flex flex-col items-center p-6 bg-white rounded-xl shadow-lg border-t-4 border-blue-600">
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold text-xl border-4 border-white">
                  {step.number}
                </div>
                <div className="mt-4 procedure-step-content">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-center text-sm">
                      {step.desc}
                    </p>
                  </div>
                  <span className="text-2xl self-center mt-4">{step.icon}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Key Documents Required for ICEGATE Registration
          </h2>
          <p className="text-center text-lg text-gray-600 max-w-4xl mx-auto mb-10">
            The documentation for ICEGATE registration is crucial for authenticating the trade entity. The following are the standard documents required.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "📋", title: "Import Export Code (IEC)", desc: "Copy of the Importer/Exporter Code certificate issued by DGFT." },
              { icon: "🏢", title: "Goods and Services Tax (GSTIN)", desc: "Copy of the GST registration certificate." },
              { icon: "🔏", title: "Valid Digital Signature Certificate (DSC)", desc: "Class 3 DSC (required for authentication and e-filing)." },
              { icon: "🆔", title: "PAN Card of Entity/Director", desc: "Permanent Account Number (PAN) card of the business entity and/or authorized signatory." }
            ].map((doc, index) => (
              <div key={index} className="p-6 bg-white rounded-xl shadow-md border-l-4 border-blue-600 flex items-start space-x-4">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{doc.title}</h3>
                  <p className="text-gray-600 text-sm">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Deliverables Section */}
      <section id="deliverables" className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Your Deliverables: What Akir Advisory Provides
            </h2>
            <p className="text-lg text-gray-600">
              Everything you need to be a legally compliant Food Business Operator in India.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🔑", title: "ICEGATE ID", desc: "This is your unique electronic identification that allows you to log in to the ICEGATE portal and use its services." },
              { icon: "📝", title: "Access to e-Filing", desc: "You can file Shipping Bills, Bills of Entry, and other customs documents online." },
              { icon: "📎", title: "Online Document Upload (e-SANCHIT)", desc: "You can upload and submit all required supporting documents electronically for customs clearance and other transactions." },
              { icon: "💸", title: "E-payment Facility", desc: "You can pay customs duties and taxes online securely through banking channels." }
            ].map((deliverable, index) => (
              <div key={index} className="p-6 bg-blue-50 rounded-xl shadow-lg border-l-4 border-blue-600 flex items-start space-x-4">
                <span className="text-2xl flex-shrink-0 mt-1">{deliverable.icon}</span>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{deliverable.title}</h3>
                  <p className="text-gray-600 text-sm">{deliverable.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="faqs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions (FAQs)
          </h2>
          <div className="max-w-4xl mx-auto space-y-6">
            {[
              { 
                question: "What is the time taken for ICEGATE Registration?", 
                answer: "The registration process is typically quick once all the correct documents, especially the DSC, are in place. We aim to complete the process and provide you with credentials within 3-5 working days of receiving all required information." 
              },
              { 
                question: "Is ICEGATE registration mandatory for all exporters and importers?", 
                answer: "Yes. ICEGATE registration is mandatory for all trade partners who wish to file electronic documents (Shipping Bills, Bills of Entry, etc.) and conduct online financial transactions with Indian Customs." 
              },
              { 
                question: "What is a Digital Signature Certificate (DSC) and why is it needed?", 
                answer: "A Class 3 Digital Signature Certificate is a secure digital key that certifies the identity of the holder. It is required for electronically signing and submitting documents on the ICEGATE portal, ensuring their authenticity and non-repudiation." 
              },
              { 
                question: "Can a Customs Broker use their own ICEGATE ID for a client?", 
                answer: "No. While a Customs Broker handles the filing, the Importer/Exporter must have their own registered ICEGATE ID to access their account, view documents, and track duty payments and refunds." 
              }
            ].map((faq, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md border-l-4 border-blue-600">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                  <span className="mr-3 text-blue-600">❓</span> {faq.question}
                </h3>
                <p className="text-gray-600 text-sm">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-10 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
           Ready to secure your ICEGATE Registration?
          </h2>
          <p className="text-lg text-blue-100 mb-8">
            Let our team of advisors simplify your Customs compliance journey.
          </p>
          <a href="#contact-section" className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-600 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
              <span className="mr-2">📞</span> Consult Our Expert Today
          </a>
        </div>
      </section>
    </main>
  );
};

export default ICEGATERegistration;